import React, {ReactNode} from 'react'
import { Hidden, BoxProps, Box, Grid, GridSize } from '@mui/material';
import { GridProps } from '@mui/material/Grid';
import {generateMedia} from 'styled-media-query'
import {BreakpointValues} from './Constants'

export const currentMedia = generateMedia({
    sp: `${BreakpointValues.md}px`,
    pc: `${BreakpointValues.md + 1}px`,
})

interface RenderSwitchByBreakPointProps {
    over?: ReactNode
    under?: ReactNode
    children?: ReactNode
}

// innerWidth  |xs      sm       md       lg       xl
//             |--------|--------|--------|--------|-------->
// width       |   xs   |   sm   |   md   |   lg   |   xl
//
// mdDown      |                     hide | show
// lgUp                              show | hide
export const HideInSP: React.FC<RenderSwitchByBreakPointProps> =
        props => <Hidden lgDown={true}>{props.children}</Hidden>
export const HideInPC: React.FC<RenderSwitchByBreakPointProps> =
        props => <Hidden lgUp={true}>{props.children}</Hidden>

export const RenderSwitchByBreakPoint: React.FC<RenderSwitchByBreakPointProps> = props => {
    return <>
        {props.over && <HideInSP>{props.over}</HideInSP>}
        {props.under && <HideInPC>{props.under}</HideInPC>}
    </>
}

export type SpacerProps = BoxProps & { children?: never }

export const BlockSpacer: React.FC<SpacerProps> = props => <Box {...props} />

export const BlockSpacerPcOnly: React.FC<SpacerProps> = props =>
    <HideInSP><BlockSpacer {...props}/></HideInSP>

export const BlockSpacerSpOnly: React.FC<SpacerProps> = props =>
    <HideInPC><BlockSpacer {...props}/></HideInPC>

export const GridBlockSpacer: React.FC<SpacerProps> = props =>
    <GridItem over={12}><BlockSpacer {...props}/></GridItem>

export const GridBlockSpacerPcOnly: React.FC<SpacerProps> = props =>
    <HideInSP><GridBlockSpacer {...props}/></HideInSP>

export const GridBlockSpacerSpOnly: React.FC<SpacerProps> = props =>
    <HideInPC><GridBlockSpacer {...props}/></HideInPC>


export interface GridContainerProps {
    alignItems?: string
    children: ReactNode
}

export const GridContainer: React.FC<GridContainerProps> = props =>
    <Grid container alignItems={props.alignItems || 'center'}>{props.children}</Grid>

export const LabeledGridContainer: React.FC<{ alignItems?: string, children: ReactNode }> = props =>
    <label><GridContainer {...props}>{props.children}</GridContainer></label>


export type GridItemProps = GridProps & {
    over: boolean | GridSize,
    under?: boolean | GridSize,
    alignSelf?: React.CSSProperties['alignSelf'],
}
export const GridItem: React.FC<GridItemProps> = props =>
    <Grid
        item
        style={{alignSelf: props.alignSelf ?? 'center'}}
        xs={props.under === undefined ? 12 : props.under}
        lg={props.over}
    >
        {props.children}
    </Grid>

